import { module as ModuleJS } from "modujs";
import { debounce } from "../utils/events";

export default class extends ModuleJS {
    constructor(m) {
        super(m);
        this.rx = parseInt(this.getData('rx')) || 1421;
        this.ry = parseInt(this.getData('ry')) || 382;
        this.width = this.el.clientWidth;
        this.height = this.el.clientHeight;
        this.y1 = 0;

        this.config = {
            xAxisRotation: 0,
            largeArcFlag: 0,
            sweepFlag: 1,
        };
    }

    init() {
        this.render = this.render.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onResizeDebounced = debounce(this.onResize, 200);

        this.onResize();
        this.bindEvents();
    }

    getX = (y) => Math.sqrt( -Math.pow(this.rx, 2) * (1 - ( Math.pow(y, 2) / Math.pow(this.ry, 2) )) )
    getY = (x) => Math.sqrt( Math.pow(this.ry, 2) * (1 - ( Math.pow(x, 2) / Math.pow(this.rx, 2) )) )

    onResize() {
        this.width = this.el.clientWidth;
        this.height = this.el.clientHeight;

        const diffY = this.height - this.ry;
        this.y1 = this.getY(this.width / 2) + diffY;
        this.render();
    }

    render() {
        const w0 = 0;
        const w1 = this.width;
        const { rx, ry, y1 } = this;
        const { xAxisRotation, largeArcFlag, sweepFlag } = this.config;

        const paths = [
            `M${w0},0`,
            `L${w1},0`,
            `L${w1},${y1}`,
            `A${rx},${ry},${xAxisRotation},${largeArcFlag},${sweepFlag},0,${y1}`,
            'Z'
        ];

        const clipPath = paths.join('');
        this.el.style.clipPath = `path('${clipPath}')`;
        this.el.style['-webkit-clip-path'] = `path('${clipPath}')`;
    }

    bindEvents(el) {
        window.addEventListener("resize", this.onResizeDebounced);
    }

    update(newContainer) {
        window.removeEventListener("resize", this.onResizeDebounced);
        window.addEventListener("resize", this.onResizeDebounced);
    }

    destroy(oldContainer) {
        window.removeEventListener("resize", this.onResizeDebounced);
    }
}
